__turbopack_context__.v({
  "animatedWrapper": "d_8L8G_animatedWrapper",
  "container": "d_8L8G_container",
  "listItem": "d_8L8G_listItem",
  "loaderWrapper": "d_8L8G_loaderWrapper",
  "productGrid": "d_8L8G_productGrid",
  "wiggle": "d_8L8G_wiggle",
});
